// Validación del registro del alta por link, sin depender del navegador.
//
// La validación nativa (`required`, `minLength`, `type=email`) frena el envío, pero en el
// navegador de Instagram en iPhone el aviso no se ve claro: el autocompletado llena
// nombre y mail, la contraseña queda vacía, y el primer "Crear cuenta" no hace nada a la
// vista. Pasaba en 5 de 9 sesiones de iPhone dentro de Instagram y en 0 de 9 de Safari y
// compu. Ver ADR-2026-10-16-pago-directo-espera-y-medicion.

export type CampoDelRegistro = 'name' | 'email' | 'password';

export type CamposDelRegistro = {
  modo: 'signup' | 'signin';
  name: string;
  email: string;
  password: string;
};

/** Mismo mínimo que tenía el `minLength` del input (y el que acepta Supabase). */
const MIN_CLAVE = 6;
const MAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** El primer campo que falta o está mal, en el orden de la pantalla, o `null`. */
export function primerCampoInvalido(
  c: CamposDelRegistro,
): { campo: CampoDelRegistro; mensaje: string } | null {
  if (c.modo === 'signup' && !c.name.trim()) {
    return { campo: 'name', mensaje: 'Escribí tu nombre y apellido.' };
  }
  if (!MAIL.test(c.email.trim())) {
    return { campo: 'email', mensaje: 'Revisá el mail: parece que le falta algo.' };
  }
  if (c.password.length < MIN_CLAVE) {
    return {
      campo: 'password',
      // Al entrar no se elige: se escribe la que ya tiene (y nunca es más corta que el
      // mínimo, que es el de Supabase).
      mensaje:
        c.modo === 'signin'
          ? 'Escribí tu contraseña.'
          : 'Elegí una contraseña de al menos 6 caracteres.',
    };
  }
  return null;
}
